export const defaultCallingContainerStyles = {
  generalStyleProps: {
    background: "#000",
    width: "100%",
    zIndex: 100,
    boxShadow: "0px 0px 2px rgba(0, 0, 0, 0.16), 0px 4px 8px rgba(0, 0, 0, 0.12)"
  }
};